import React from 'react';
import '../../styles/layout.css';

/**
 * ColumnElement - Vertical container within a row
 * Can contain other elements including nested rows
 * Uses 12-column span system (1-12) with configurable flexbox layout
 */
const ColumnElement = ({ element, children, isEditorMode }) => {
  const { props } = element;
  const {
    span = 12, // 1-12 columns to span (new preferred prop)
    width = 'auto', // Backward compatibility
    padding = 'medium',
    backgroundColor = 'transparent',
    // Flexbox layout controls
    flexDirection = 'column',
    justifyContent = 'flex-start',
    alignItems = 'stretch',
    gap = 'medium'
  } = props || {};

  // Map gap values to CSS values
  const gapMap = {
    none: '0',
    small: '0.5rem',
    medium: '1rem',
    large: '1.5rem'
  };

  const style = {
    flexDirection,
    justifyContent,
    alignItems,
    gap: gapMap[gap] || gapMap.medium
  };

  if (backgroundColor && backgroundColor !== 'transparent') {
    style.backgroundColor = backgroundColor;
  }

  return (
    <div
      className={`builder-column ${isEditorMode ? 'builder-editor-mode' : ''}`}
      data-span={span}
      data-width={width} // Keep for backward compatibility
      data-padding={padding}
      style={style}
    >
      {children}
    </div>
  );
};

export default ColumnElement;
